<template>
    <div class="modal" id="createEditPresetModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen-custom">
            <div class="modal-content">
                <div class="modal-header bg-white">
                    <h5 class="modal-title text-teal font-medium">{{ createEditPresetTextObj.modalTitle }}</h5>
                    <button type="button" class="close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body modal-scrollable">
                    <div class="row p-2">
                        <div class="col-12">
                            <div id="accordionChoosePermissions">
                                <!-- Accordion Item 1 -->
                                <div class="card mb-0">
                                    <div class="card-header custom-card-header" id="presetName">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link custom-btn-link text-grey-darker collapsed" data-toggle="collapse" data-target="#collapsePresetName" aria-expanded="false" aria-controls="collapsePresetName">
                                                <i class="fa fa-angle-right text-primary mr-3"></i>Enter preset name
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="collapsePresetName" class="collapse" aria-labelledby="presetName" data-parent="#accordionChoosePermissions">
                                        <div class="card-body custom-card-body bg-white">
                                            <div class="col-12">
                                                <b-form-input
                                                    v-model="preset.name"
                                                    :disabled="preset.is_default"
                                                    placeholder="Enter preset name">
                                                </b-form-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Accordion Item 2 -->
                                <div class="card">
                                    <div class="card-header custom-card-header" id="choosePermissions">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link custom-btn-link text-grey-darker collapsed" data-toggle="collapse" data-target="#collapseChoosePermissions" aria-expanded="false" aria-controls="collapseChoosePermissions">
                                                <i class="fa fa-angle-right text-primary mr-3"></i>Choose permissions
                                            </button>
                                        </h5>
                                    </div>
                                    <div id="collapseChoosePermissions" class="collapse" aria-labelledby="choosePermissions" data-parent="#accordionChoosePermissions">
                                        <div class="card-body custom-card-body bg-white">
                                            <div class="col-12">
                                                <choose-permissions
                                                    :team="team"
                                                    ref="ChoosePermissions">
                                                </choose-permissions>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click="close">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="savePreset()">{{ createEditPresetTextObj.saveBtnText }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ChoosePermissions from "./choose-permissions.vue";

export default {
    name: 'create-edit-preset-modal',
    components: {ChoosePermissions},
    props: ['team', 'createEditPresetTextObj', 'editSelectedPreset'],
    data() {
        return {
            preset: {
                id: null,
                name: null
            },
            permissions: []
        }
    },
    watch: {
        editSelectedPreset: {
            handler: function(newValue) {
                this.preset.id = newValue.id;
                this.preset.name = newValue.name;
                this.permissions = newValue.permissions;
                this.$refs.ChoosePermissions.mapSavedPermissions(this.permissions);
            },
            deep: true
        }
    },
    methods: {
        open() {
            $("#createEditPresetModal").modal("show");
        },
        close() {
            this.resetForm();
            $("#createEditPresetModal").modal("hide");
        },
        savePreset() {
            let self = this;

            if(self.preset.name === null || self.preset.name.trim() === "") {
                this.getToast().fire({
                    type: 'error',
                    title: 'Enter preset name!'
                });

                return false;
            }

            const payload = {
                preset: self.preset,
                permissions: self.$refs.ChoosePermissions.selectedPermissions
            };

            axios.post('/settings/'+this.team.id+'/permissions/roles/save', payload).then(({data}) => {
                this.$emit('preset-saved');
                this.resetForm();
                this.close();
                this.getToast().fire({
                    type: 'success',
                    title: 'Preset saved successfully.'
                });
            }).catch(error => {
                if(error.response && error.response.status === 422) {
                    const errors = error.response.data.errors;

                    if(errors.name) {
                        this.getToast().fire({
                            type: 'error',
                            title: errors.name[0]
                        });
                    }
                }
            });
        },
        resetForm() {
            this.preset.id = null;
            this.preset.name = null;
            this.permissions = [];
            $('#collapseChoosePermissions').collapse('hide');
            this.$refs.ChoosePermissions.resetData();
        }
    }
}
</script>

<style scoped>
.card .custom-card-header {
    border-color: rgb(203, 214, 226);
    background-color: rgb(245, 248, 250);
    padding: .5rem .75rem;
    border-width: 1px 1px;
    border-bottom: none;
    border-radius: unset;
}
.card .custom-card-body {
    border-width: 1px 1px;
}
.custom-btn-link {
    text-decoration: none;
    box-shadow: none;
    outline: none;
    font-size: 15px;
    font-weight: 600;
}
.custom-btn-link:hover {
    text-decoration: none;
    color: #01B1AF;
}
.modal-fullscreen-custom {
    height: 100vh;
    display: flex;
    flex-direction: column;
    margin: 0;
    border: none;
    border-radius: 0;
    max-width: 100% !important;
}
.modal-fullscreen-custom .modal-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1051;
    height: 62px;
}
.modal-fullscreen-custom .modal-footer {
    position: fixed;
    bottom: 5px;
    left: 0;
    right: 0;
    z-index: 1051;
    height: 62px;
}
.modal-fullscreen-custom .modal-scrollable {
    overflow-y: auto;
    flex: 1 1 auto;
    margin-top: 70px;
    margin-bottom: 70px;
    padding: 15px;
}
.modal-fullscreen-custom .modal-content {
    height: 100vh;
    display: flex;
    flex-direction: column;
}
.modal-fullscreen-custom .modal-header,
.modal-fullscreen-custom .modal-footer {
    flex-shrink: 0;
}
.modal-fullscreen-custom .modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
}
</style>
